const API_URL = process.env.REACT_APP_API_URL;

export const sendEmail = async (data) => {
  const response = await fetch(API_URL, {
    method: 'POST',
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || 'Erro ao enviar e-mail');
  }

  return response.json();
};